<div class="forbidden-page">
    <div class="inner-container">
        <div class="message-box">
            <h1>You shall not pass!</h1>
            <h3>Looks like you're not supposed to be here.</h3>
            <img src="../../../assets/403/shallnotpass.gif" alt="">
        </div>
    </div>
</div>
